import { api, createCancelTokenHandler } from "../../vodea/services";

const endPoint = () => process.env.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  all: function (brandId: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/brand/${brandId}/order`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
          .token,
    });
  },
  show: function (
    brandId: number | string,
    id: number | string,
    params: any = null
  ) {
    return api.get(`${endPoint()}/api/brand/${brandId}/order/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.show.name].handleRequestCancellation()
          .token,
    });
  },
  replaceProduct: function (
    brandId: number | string,
    orderId: number | string,
    payload: any,
    params: any = null
  ) {
    return api.put(
      `${endPoint()}/api/brand/${brandId}/order/${orderId}/replace-product`,
      payload,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.replaceProduct.name
          ].handleRequestCancellation().token,
      }
    );
  },
};

export default Repository;

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);
